// removed by extract-text-webpack-plugin
module.exports = {"search":"main_nav-3ND","input":"main_nav-3NO","search-icon":"main_nav-1jE","search-icon-mobile":"main_nav-3GQ","overflow-icon":"main_nav-2y1","searching":"main_nav-20-","hamburger-close-icon":"main_nav-1qN"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Search/search.module.scss
// module id = 130
// module chunks = 0